import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingle,
  Update,
  GetAll,
} from "../../../../../../../features/admin/quality_management/structural_requirement/legal_entity/Slice";

import { formatDateForInput } from "../../../../../../../utils/common";

function Legel_Entity_Edit_offcanvas({ show, handleClose, id }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      setLoading(true);
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.data;

        reset({
          name: data.name,
          legal_entity: data.legal_entity,
          date_of_establishment: formatDateForInput(data.date_of_establishment),
          other_accereditation: data.other_accereditation,
          attach_file: data?.attach_file,
          companies_act_certificate: data?.companies_act_certificate,
        });
      } else {
        setShowError(res.payload?.response?.data?.errors);
      }
      // reset(res?.payload?.data)
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && id) {
      GetData(id);
    }
  }, [show, id]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data.name);
      sendData.append("legal_entity", data.legal_entity);
      sendData.append("date_of_establishment", data.date_of_establishment);
      sendData.append("other_accereditation", data.other_accereditation || "");

      sendData.append(
        "companies_act_certificate",
        data.companies_act_certificate[0],
      );

      sendData.append("attach_file", data.attach_file[0]);

      const res = await dispatch(Update({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAll());

        setTimeout(() => {
          setSuccess(false);
          setRemovedFiles([]); // ✅ reset
          handleClose();
        }, 1500);
      } else {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  const handleRemoveCompanies = () => {
    setCompaniesPreview(null);
    setValue("companies_act_certificate", null);
    setRemovedFiles((prev) =>
      prev.includes("companies_act_certificate")
        ? prev
        : [...prev, "companies_act_certificate"],
    );
  };

  const handleRemoveAttach = () => {
    setAttachPreview(null);
    setValue("attach_file", null);
    setRemovedFiles((prev) =>
      prev.includes("attach_file") ? prev : [...prev, "attach_file"],
    );
  };

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Legal Entity
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Legal Entity Name</Form.Label>
                  <Form.Control
                    {...register("name", {
                      required: "Legal Entity Name is required",
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Legal Entity Type</Form.Label>
                  <Form.Control
                    {...register("legal_entity", {
                      required: "Legal Entity Type is required",
                    })}
                  />
                  {errors.legal_entity && (
                    <span className="text-danger">
                      {errors.legal_entity.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Date of Establishment</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("date_of_establishment", {
                      required: "Date of Establishment is required",
                      // validate: (value) => {
                      //   const year = value.split("-")[0];

                      //   if (year.length !== 4) {
                      //     return "Year must be exactly 4 digits";
                      //   }

                      //   const selectedDate = new Date(value);
                      //   const today = new Date();
                      //   today.setHours(0, 0, 0, 0);

                      //   if (selectedDate < today) {
                      //     return "Past dates are not allowed";
                      //   }

                      //   return true;
                      // },
                    })}
                    onChange={(e) => {
                      let value = e.target.value;
                      const parts = value.split("-");

                      if (parts[0] && parts[0].length > 4) {
                        parts[0] = parts[0].slice(0, 4);
                        e.target.value = parts.join("-");
                      }
                    }}
                  />
                  {errors.date_of_establishment && (
                    <span className="text-danger">
                      {errors.date_of_establishment.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Type Of Service</Form.Label>
                  <Form.Control
                    {...register("other_accereditation", {
                      required: "Type Of Service is required",
                    })}
                  />
                  {errors.other_accereditation && (
                    <span className="text-danger">
                      {errors.other_accereditation.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              {/* Companies Act Certificate */}
              <div className="col-md-7">
                <Form.Group className="form_group file_field">
                  <Form.Label>Companies Act Certificate</Form.Label>
                  <Form.Control
                    type="file"
                    {...register("companies_act_certificate", {
                      required:
                        typeof getValues("companies_act_certificate") ===
                        "string"
                          ? false
                          : "File is required",
                    })}
                    accept="*"
                  />
                  {(() => {
                    const fileValue = watch("companies_act_certificate");
                    const fileUrl =
                      typeof fileValue === "string"
                        ? process.env.REACT_APP_IMG_URL + fileValue
                        : fileValue?.length > 0
                        ? URL.createObjectURL(fileValue[0])
                        : null;

                    // Type detection
                    const fileType =
                      typeof fileValue === "string"
                        ? fileValue.toLowerCase()
                        : fileValue?.[0]?.type;

                    if (!fileUrl) return null;

                    return (
                      <div className="image_holder mt-2">
                        {(fileType?.includes("image") ||
                          fileType?.endsWith(".jpg") ||
                          fileType?.endsWith(".jpeg") ||
                          fileType?.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="img_preview"
                          />
                        )}

                        {/* PDF */}
                        {(fileType === "application/pdf" ||
                          fileType?.endsWith(".pdf")) && (
                          <iframe
                            src={fileUrl}
                            style={{ maxWidth: "100px" }}
                            title="PDF"
                            className="img_preview"
                          />
                        )}

                        {/* WORD */}
                        {(fileType?.includes("word") ||
                          fileType?.endsWith(".doc") ||
                          fileType?.endsWith(".docx")) && (
                          <div>
                            <p>Word preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                              className="img_preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType?.includes("spreadsheet") ||
                          fileType?.endsWith(".xlsx") ||
                          fileType?.endsWith(".xls")) && (
                          <div className="img_preview">
                            <p>Excel preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                  {/* <div className="image_holder">
                    <img
                      src={
                        companiesPreview ||
                        "/assets/images/other/dummy-image.png"
                      }
                      className="img_preview"
                      alt=""
                    />
                    {companiesPreview && (
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        className="delete_icon"
                        onClick={handleRemoveCompanies}
                      />
                    )}
                  </div> */}
                </Form.Group>
              </div>

              {/* Attach File */}
              <div className="col-md-7">
                <Form.Group className="form_group file_field">
                  <Form.Label>Attached File</Form.Label>
                  <Form.Control
                    type="file"
                    {...register("attach_file", {
                      required:
                        typeof getValues("attach_file") === "string"
                          ? false
                          : "File is required",
                    })}
                    accept="*"
                  />

                  {/* <div className="image_holder">
                    <img
                      src={
                        attachPreview || "/assets/images/other/dummy-image.png"
                      }
                      className="img_preview"
                      alt=""
                    />
                    {attachPreview && (
                      <FontAwesomeIcon
                        icon={faTrashCan}
                        className="delete_icon"
                        onClick={handleRemoveAttach}
                      />
                    )}
                  </div> */}

                  {(() => {
                    const fileValue = watch("attach_file");

                    // URL for preview
                    const fileUrl =
                      typeof fileValue === "string"
                        ? process.env.REACT_APP_IMG_URL + fileValue
                        : fileValue?.length > 0
                        ? URL.createObjectURL(fileValue[0])
                        : null;

                    // Type detection
                    const fileType =
                      typeof fileValue === "string"
                        ? fileValue.toLowerCase()
                        : fileValue?.[0]?.type;

                    if (!fileUrl) return null;

                    return (
                      <div className="image_holder mt-2">
                        {(fileType?.includes("image") ||
                          fileType?.endsWith(".jpg") ||
                          fileType?.endsWith(".jpeg") ||
                          fileType?.endsWith(".png")) && (
                          <img
                            src={fileUrl}
                            alt="Preview"
                            className="img_preview"
                          />
                        )}

                        {/* PDF */}
                        {(fileType === "application/pdf" ||
                          fileType?.endsWith(".pdf")) && (
                          <iframe
                            src={fileUrl}
                            style={{ maxWidth: "100px" }}
                            title="PDF"
                            className="img_preview"
                          />
                        )}

                        {/* WORD */}
                        {(fileType?.includes("word") ||
                          fileType?.endsWith(".doc") ||
                          fileType?.endsWith(".docx")) && (
                          <div>
                            <p>Word preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Word File
                            </a>

                            <iframe
                              src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                              style={{ maxWidth: "100px" }}
                              title="Word Preview"
                              className="img_preview"
                            />
                          </div>
                        )}

                        {/* EXCEL */}
                        {(fileType?.includes("spreadsheet") ||
                          fileType?.endsWith(".xlsx") ||
                          fileType?.endsWith(".xls")) && (
                          <div className="img_preview">
                            <p>Excel preview not supported</p>
                            <a
                              href={fileUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open / Download Excel File
                            </a>
                          </div>
                        )}
                      </div>
                    );
                  })()}
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Legel_Entity_Edit_offcanvas;
